/// <reference types="vite/client" />
import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { showSnackbar } from '@/shared/hooks/useSnackbar';
import i18n from '@/shared/i18n';
import { noteServerRequestId } from '@/shared/utils/apiError';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001';

const API_URL = BASE_URL.endsWith('/api') ? BASE_URL : `${BASE_URL}/api`;

console.log('🔍 API Configuration Debug:');
console.log('   VITE_API_URL:', import.meta.env.VITE_API_URL);
console.log('   BASE_URL:', BASE_URL);
console.log('   Final API_URL:', API_URL);

const apiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    try {
      const clinicScope = localStorage.getItem('clinicScope');
      if (clinicScope && config.headers && !config.headers['X-Clinic-Scope']) {
        config.headers['X-Clinic-Scope'] = clinicScope;
      }
    } catch {
      // Ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const handleUnauthorized = (error: unknown): void => {
  const err = error as {
    response?: { status?: number; data?: { code?: string } };
    config?: { url?: string };
  };
  if (err.response?.status !== 401) return;

  const url = err.config?.url || '';
  if (url.includes('/auth/login') || url.includes('/auth/logout')) {
    return;
  }

  const code = err.response?.data?.code;
  localStorage.removeItem('token');
  if (code === 'SESSION_INVALID') {
    showSnackbar(i18n.t('auth:sessionInvalid'), 'error');
  }
  if (!window.location.pathname.includes('/login')) {
    window.location.href = '/login';
  }
};

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    noteServerRequestId(error);
    handleUnauthorized(error);
    return Promise.reject(error);
  }
);

export { API_URL, apiClient };
export default apiClient;
